import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-sm bg-card rounded-lg shadow p-8">
        <h1 className="text-2xl font-bold mb-2">Forgot password?</h1>
        {submitted ? (
          <>
            <p className="text-sm text-muted-foreground mb-4">
              If that email address is registered, you'll receive a password reset link shortly.
            </p>
            <p className="text-sm text-center">
              <Link to="/login" className="text-primary hover:underline">Back to login</Link>
            </p>
          </>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mb-4">
              Enter your email and we'll send you a reset link.
            </p>
            {error && <p className="text-red-600 text-sm mb-4">{error}</p>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email" placeholder="Email" value={email}
                onChange={(e) => setEmail(e.target.value)} required
                className="w-full border rounded px-3 py-2 text-sm bg-background"
              />
              <button type="submit" className="w-full bg-primary text-primary-foreground rounded py-2 text-sm hover:opacity-90">
                Send reset link
              </button>
            </form>
            <p className="text-sm text-muted-foreground mt-4 text-center">
              <Link to="/login" className="text-primary hover:underline">Back to login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
